module.exports = __webpack_public_path__ + "static/media/400100_02.63b58eb2.png";